<template>
  <div v-loading.fullscreen="!isCriticalDataReady">
    <div v-if="isCriticalDataReady" class="page-wrapper">
      <app-header />
      <section class="page-middle container">
        <aside class="page-aside">
          <div class="page-aside__bg"></div>
          <div class="page-aside__content">
            <app-sidebar />
          </div>
        </aside>
        <div class="page-content-wrapper">
          <main class="page-content">
            <router-view />
          </main>
          <div class="page-footer">
            <app-footer />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import appSidebar from '@/components/sidebar/Sidebar'
  import appHeader from '@/components/Header'
  import appFooter from '@/components/Footer'
  import { isEmpty } from 'lodash'

  export default {
    components: {
      appSidebar,
      appHeader,
      appFooter
    },

    computed: {
      isCriticalDataReady() {
        const routes = !isEmpty(this.$store.state.routes.routes)
        const acc = !isEmpty(this.$store.state.user.accInfo)
        // return routes && acc
        return true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-wrapper {
    min-height: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }
  .page-middle {
    flex-grow: 1;
    display: flex;
  }

  // ================= SIDEBAR ====================

  .page-aside {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    pointer-events: none;
    z-index: 10;
    * {
      visibility: visible;
    }
    @media (min-width: $viewport-sm) {
      pointer-events: initial;
      position: static;
      width: 270px;
      min-width: 270px;
      height: auto;
      margin-right: 28px;
      margin-bottom: 24px;
    }
  }

  body.sidebar-open {
    .page-aside__bg {
      visibility: visible;
      opacity: .3;
    }
    .page-aside__content {
      transform: none;
      background: #fff;
      box-shadow: $box-shadow-md;
    }
  }

  .page-aside__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    opacity: 0;
    transition: .3s;
    background: #000;
    @media (min-width: $viewport-sm) {
      display: none;
    }
  }
  .page-aside__content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 270px;
    pointer-events: auto;
    transform: translateX(-100%);
    transition: transform .3s;
    will-change: transform;
    overflow-y: auto;
    @media (min-width: $viewport-sm) {
      position: static;
      transform: none;
    }
  }

  // =====================================

  .page-content-wrapper {
    overflow: hidden;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  .page-content {
    flex-grow: 1;
  }
</style>
